import { createContext } from 'react';
import { WalletStore } from '../store/walletStore';

export const WalletContext = createContext<WalletStore | null>(null);
